import { createSelector } from '@reduxjs/toolkit';
import { employeesShortNames } from './employees-short-names';
import { currentEmployeeUuid } from './current-employee-uuid';

export const currentEmployeeShortName = createSelector(
  employeesShortNames,
  currentEmployeeUuid,
  function (employees: { uuid: string; status: string; name: string }[], currentEmployeeUuid): string | undefined {
    const names = employees.filter(function (e) {
      return e.uuid === currentEmployeeUuid;
    });
    if (names.length) {
      return names[0].name;
    }
    return undefined;
  },
);
